import { api } from "./api";

let pending = null;

export function loadInstallations(force = false) {
  if (!pending || force) {
    pending = api
      .installations()
      .then((rows) => (Array.isArray(rows) ? rows : rows?.items || []))
      .catch((e) => {
        pending = null;
        throw e;
      });
  }
  return pending;
}

export function installationName(list, id) {
  const row = (list || []).find((i) => i.id === id);
  return row ? `${row.name} (${row.code})` : id ? String(id) : "";
}
